import { TemplateService } from './template.service';
import {
  Directive,
  Input,
  ViewContainerRef,
  OnInit,
  OnChanges,
} from '@angular/core';

@Directive({
  selector: '[templateHost]',
  standalone: true,
})
export class TemplateDirective implements OnChanges {
  @Input() data: DirectiveData;
  @Input() customStyles: StyleData[];

  constructor(
    public viewContainerRef: ViewContainerRef,
    protected templateService: TemplateService
  ) {}

  ngOnChanges(): void {
    const componentRef = this.templateService.resolveComponent(
      this.viewContainerRef,
      this.data.componentName
    );

    componentRef.instance.data = this.data.sectionData;

    if (this.customStyles) {
      this.customStyles.forEach((styleElement) => {
        const element = (
          componentRef.location.nativeElement as HTMLElement
        ).getElementsByClassName(styleElement.elementClass)[0] as HTMLElement;
        element.style.setProperty(
          styleElement.styleKey,
          styleElement.styleValue
        );
      });
    }
  }
}

interface DirectiveData {
  componentName: string;
  sectionData: any;
}

interface StyleData {
  elementClass: string;
  styleKey: string;
  styleValue: string;
}
